function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrownPurpleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    height: 11,
    id: "screenshot-168342bd-0dde-8049-8007-c4aef130e8e2",
    viewBox: "1732 2219 15 11",
    style: {
      WebkitPrintColorAdjust: ":exact"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-168342bd-0dde-8049-8007-c4aef130e8e2",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    id: "render-1704-Layer_2",
    viewBox: "0 0 32.07 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "render-1704-Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,18.81H4.29C2.73,12.77,0,4.1,0,4.03l.2.35c.08.08,5.86,7.25,9.15,6.57,2.33-.48,4.59-3.26,6.64-10.32l.12-.63.16.63c2.05,7.06,4.36,9.84,6.69,10.32,3.29.68,8.66-6.06,8.82-6.3l.31-.47s-2.51,8.59-4.07,14.63Z",
    style: {
      fill: "#dca600",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29,23.79c0,.67.54,1.21,1.21,1.21h21.28c.67,0,1.21-.54,1.21-1.21v-3.34H4.29v3.34Z",
    style: {
      fill: "#dca600",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "render-1704-Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,18.81H4.29C2.73,12.77,0,4.1,0,4.03l.2.35c.08.08,5.86,7.25,9.15,6.57,2.33-.48,4.59-3.26,6.64-10.32l.12-.63.16.63c2.05,7.06,4.36,9.84,6.69,10.32,3.29.68,8.66-6.06,8.82-6.3l.31-.47s-2.51,8.59-4.07,14.63Z",
    style: {
      fill: "#dca600",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29,23.79c0,.67.54,1.21,1.21,1.21h21.28c.67,0,1.21-.54,1.21-1.21v-3.34H4.29v3.34Z",
    style: {
      fill: "#dca600",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-168342bd-0dde-8049-8007-c4aef130e8e3",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-168342bd-0dde-8049-8007-c4aef130e8e3"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 1732,
    y: 2219,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    width: 14.99065122195725,
    height: 11,
    fill: "none",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-168342bd-0dde-8049-8007-c4aef130e8e4"
  }, /*#__PURE__*/React.createElement("defs", {
    style: {
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-168342bd-0dde-8049-8007-c4aef130e8e5",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-168342bd-0dde-8049-8007-c4aef130e8e6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-168342bd-0dde-8049-8007-c4aef130e8e6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1745.08837890625,2227.2763671875L1734.00537109375,2227.2763671875C1733.276123046875,2224.618896484375,1732,2220.803955078125,1732,2220.77294921875L1732.093505859375,2220.92724609375C1732.130859375,2220.96240234375,1734.832763671875,2224.1171875,1736.37060546875,2223.81787109375C1737.459716796875,2223.606689453125,1738.51611328125,2222.383544921875,1739.474365234375,2219.27734375L1739.5302734375,2219L1739.60546875,2219.27734375C1740.5634765625,2222.383544921875,1741.643310546875,2223.606689453125,1742.732421875,2223.81787109375C1744.270263671875,2224.1171875,1746.7802734375,2221.151611328125,1746.85498046875,2221.0458984375L1747,2220.8388671875C1747,2220.8388671875,1745.826904296875,2224.618896484375,1745.09765625,2227.2763671875Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-168342bd-0dde-8049-8007-c4aef130e8e7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-168342bd-0dde-8049-8007-c4aef130e8e7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1734.00537109375,2229.4677734375C1734.00537109375,2229.76220703125,1734.2578125,2230,1734.571044921875,2230L1744.51806640625,2230C1744.831298828125,2230,1745.08349609375,2229.76220703125,1745.08349609375,2229.4677734375L1745.08349609375,2227.997802734375L1734.00537109375,2227.997802734375L1734.00537109375,2229.4677734375Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a",
      fillOpacity: 1
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownPurpleIcon);
export default __webpack_public_path__ + "static/media/CrownPurpleIcon.5182c44a3be4d72f9faf2323238d865c.svg";
export { ForwardRef as ReactComponent };